export default __webpack_public_path__ + "static/media/2.3ea71ad2.png";